import type { Persona } from '../greeting'
import type { WidgetContext } from './types'

/**
 * The facts every widget reasons over, derived once for the whole board.
 *
 * Kept separate from the data provider so it stays pure — a widget's
 * `relevance` is only unit-testable if the thing it reads is a plain object.
 */

export interface WidgetContextInput {
  personas: Persona[]
  runsLeague: boolean
  hasOrgs: boolean
  hasTrust: boolean
  counts: WidgetContext['counts']
}

export function widgetContext(input: WidgetContextInput): WidgetContext {
  const { personas, counts } = input

  // Everything but 'player' is a role that acts on OTHER people's behalf.
  const operators = personas.filter((p) => p !== 'player').length

  return {
    personas,
    // Wearing several hats at once. A player on three teams is still one
    // persona — it takes an operator role to make the same fixture reachable
    // through more than one relationship, which is what the tags explain.
    multiPersona: personas.length > 1 && operators > 0,
    runsLeague: input.runsLeague,
    hasOrgs: input.hasOrgs,
    brandNew:
      !input.hasOrgs &&
      counts.teams === 0 &&
      counts.upcoming === 0 &&
      counts.needsYou === 0,
    hasTrust: input.hasTrust,
    counts,
  }
}
